module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel Weidner, Sage Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Daniel Weidner is Professor of Comparative Literature at Martin Luther University of Halle-Wittenberg. He is the author of "), _c('I', [_vm._v("Bibel und Literatur um 1800 ")]), _vm._v("and editor of the "), _c('I', [_vm._v("Handbuch Literatur und Religion, Blumenberg Lesen: Ein Glossar")]), _vm._v(", and "), _c('I', [_vm._v("Profanes Leben: Walter Benjamins Dialektik der Säkularisierung")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yXYy8u/tc-custom/9780253062109.jpg?1721451107789",
      "alt": "This image is the cover for the book Father of Jewish Mysticism, New Jewish Philosophy and Thought"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Father of Jewish Mysticism, New Jewish Philosophy and Thought\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("The Father of Jewish Mysticism")]), _vm._v(" offers an incisive look at the early life and writings of Gershom Scholem (1897–1982), the father of modern Jewish mysticism and a major 20th-century Jewish intellectual. ")]), _c('p', [_vm._v("Daniel Weidner offers the first full-length study, published in English, of Scholem's thought. Scholem, a historian ofthe Kabbalah and sharp critic of Jewish assimilation, played a major role in the study and popularization of Jewish mysticism.")]), _c('p', [_vm._v("Through his work on the Kabbalah, Scholem turned the closed world of mystical texts into a force for Jewish identity. Skillfully drawing on Scholem's early diaries and writings, "), _c('i', [_vm._v("The Father of Jewish Mysticism")]), _vm._v(" introduces a young, soon-to-be legendary intellectual in search of himself and Judaism.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0